import { render, staticRenderFns } from "./types.vue?vue&type=template&id=745f4bae&scoped=true&"
import script from "./types.vue?vue&type=script&lang=js&"
export * from "./types.vue?vue&type=script&lang=js&"
import style0 from "./types.vue?vue&type=style&index=0&id=745f4bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f4bae",
  null
  
)

export default component.exports